import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./Pages/Home/Home";
import LoginCallback from "./Components/Auth/LoginCallback";
import SecureRoute from "./Components/Auth/SecureRoute";

import { useGlobalContext } from "./context/ConversationsProvider";
import Chat from "./Components/Chat/Chat";
import Loader from "./Components/common/Loader";
import { useAuth } from "./context/AuthProvider";

import "./style/App.css";
import "./style/media.css";
function App() {
  const { isCheckingData } = useGlobalContext();

  const { authState } = useAuth();
  useEffect(() => {
    console.log("App Version: 2.4.0");
  }, []);

  if (authState.isLoading) {
    return <Loader />;
  }

  return (
    <>
      <Routes>
        <Route path="/login-callback" element={<LoginCallback />} />

        <Route
          path="/:clientId"
          element={
            <SecureRoute>
              <Home />
            </SecureRoute>
          }
        >
          <Route index element={<Chat />} />
          <Route path="c/:conversationId" element={<Chat />} />
        </Route>

        {/* Root carries no client segment yet. ClientsProvider resolves the
            selected client and redirects to /:clientId, so we just hold
            behind the auth gate until that redirect happens. */}
        <Route
          path="/"
          element={
            <SecureRoute>
              <Loader />
            </SecureRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {isCheckingData && <Loader />}
    </>
  );
}

export default App;
